import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { ensureChildrenVisibility } from '../../../../../select/internal';
import { generateDataTestId } from '../../../../../internal/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export function YearPicker(props) {
  var selected = props.selected,
    onChange = props.onChange,
    width = props.width,
    height = props.height,
    dataTestId = props.dataTestId;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var initialSelected = React.useMemo(function () {
    return selected;
  }, []);

  // Предполагаю что людей старше 120 лет не будет
  var min = props.min || initialSelected - 120;
  // Предполагаю что горизон планирования не более 80 лет
  var max = props.max || initialSelected + 79;
  var years = React.useMemo(function () {
    return new Array(max - min + 1).fill(null).map(function (_, i) {
      return min + i;
    });
  }, [min, max]);
  var containerRef = React.useRef(null);
  var selectedRef = React.useRef(null);
  React.useEffect(function () {
    var selectedElement = selectedRef.current;
    var containerElement = containerRef.current;
    if (!selectedElement || !containerElement) {
      return;
    }
    ensureChildrenVisibility(containerElement, selectedElement);
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    ref: containerRef,
    style: {
      width: width,
      height: height
    },
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['years'],
      children: years.map(function (year) {
        return /*#__PURE__*/_jsx("button", {
          type: "button",
          className: clsx(styles['year'], selected === year && styles['selected']),
          onClick: function onClick() {
            onChange(year);
          },
          ref: selected === year ? selectedRef : null,
          "data-testid": generateDataTestId(dataTestId, ["".concat(year)]),
          children: year
        }, year);
      })
    })
  });
}